const STORAGE_KEY = 'crm_priority_orders';
const CHANGE_EVENT = 'crm-priority-orders-changed';

function readList() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    const parsed = stored ? JSON.parse(stored) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function writeList(list) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  window.dispatchEvent(new CustomEvent(CHANGE_EVENT, { detail: list }));
}

export function getPriorityOrderIds() {
  return readList();
}

export function setPriorityOrderIds(ids) {
  const unique = [...new Set((ids || []).filter(Boolean))];
  writeList(unique);
  return unique;
}

/** Adds an order to the Customer Service priority queue. Returns true when newly added. */
export function addPriorityOrderId(orderId) {
  if (!orderId) return false;
  const list = readList();
  if (list.includes(orderId)) return false;
  writeList([...list, orderId]);
  return true;
}

export function removePriorityOrderId(orderId) {
  if (!orderId) return false;
  const list = readList();
  if (!list.includes(orderId)) return false;
  writeList(list.filter((id) => id !== orderId));
  return true;
}

export function subscribePriorityOrderIds(callback) {
  const onStorage = (event) => {
    if (event.key === STORAGE_KEY) {
      callback(readList());
    }
  };
  const onCustom = (event) => {
    callback(event.detail || readList());
  };

  window.addEventListener('storage', onStorage);
  window.addEventListener(CHANGE_EVENT, onCustom);
  return () => {
    window.removeEventListener('storage', onStorage);
    window.removeEventListener(CHANGE_EVENT, onCustom);
  };
}
